<template>
  <div class="w-1200">
    <div class="activty-box">
      <div class="activty-img-box">
        <img :src="imgUrl"/>
      </div>
      <div class="activty-list">
        <div class="activty-top">
          <!--<div style="margin-left: 450px;width: 100%; padding-top: 30px;">-->
          <span class="activty-title">{{ activtyData.name }}</span>
          <div class="activty-top-time">
            <!--<span class="activty-top-time-l">2019年10月9日 13:30 ～ 2019年10月9日 18:30</span>-->
            <span class="activty-top-time-l">{{ `${activtyData.starttime}  ～  ${activtyData.endtime}` }}</span>
            <span class="activty-top-time-r">限额{{ activtyData.psnnum }}人</span>
          </div>
          <span class="activty-top-address">{{ activtyData.site }}</span>
          <!--<div class="activty-top-introduce">{{ activtyData.introduce }}</div>-->
          <!--</div>-->
        </div>
        <div class="activty-med">
          <div class="activty-med-l">
            活动票种
          </div>
          <div class="activty-med-r">
            <div class="price-list">
              <div class="price-box">
                <span>￥{{ activtyData.earlybirdprice }}</span>
                <span>早鸟价</span>
              </div>
              <div class="price-box">
                <span>￥{{ activtyData.mmbrapplychrg }}</span>
                <span>会员价</span>
              </div>
              <div class="price-box">
                <span>￥{{ activtyData.unmmbrapplychrg }}</span>
                <span>非会员价</span>
              </div>
            </div>
            <div class="introduce">报名说明：点击我要报名，跳转到会员系统-->注册基本信息-->登录系统，进行报名！</div>
          </div>
        </div>
        <div class="activty-bot">
          <div class="activty-bot-btn" @click="goUser">我要报名</div>
        </div>
      </div>
    </div>
    <div class="activty-rich-title">活动内容</div>
    <div class="activty-rich" v-html="activtyData.introduce"></div>
    <div class="activty-rich-title" style="margin-bottom: 24px;">活动回顾</div>
    <event-review
      :data="otherActivty"
      @goPage="goBack"
    >
    </event-review>
  </div>
</template>

<script>
  import api from '../../model/api';
  import eventReview from './event-review';

  export default {
    name: 'activty-detail',
    components: {
      eventReview
    },
    props: {},
    data() {
      return {
        params: {},
        activtyData: {},
        imgUrl: '',
        otherActivty: [], // 其他回顾活动
        page: 1,
        lines: 16
      };
    },
    watch: {},
    computed: {},
    methods: {
      goUser() {
        window.open('http://39.105.49.146/cana/user#/login', '_blank');
      },
      getActivtyData(id) {  // 获取活动信息
        let vars = {};
        vars.module = 'bsmMaActvtyQuery';
        vars.key = 'getactivity';
        vars.paging = [];
        vars.conds = [
          `id=${id}`
        ];
        vars.dims = [];
        api.sQuery(vars, this, data => {
          console.log(data.data[0])
          this.activtyData = data.data[0]
          this.imgUrl = JSON.parse(data.data[0].banner)[0].$path
        });
      },
      getOtherActivtyData() {  // 获取其他回顾活动
        let vars = {};
        vars.module = 'bsmMaActvtyQuery';
        vars.key = 'getactivity';
        vars.paging = [
          this.page,
          this.lines
        ];
        vars.conds = [
          `review_status=已结束`
        ];
        vars.dims = [];
        vars.order = ['id', 'DESC'];
        api.sQuery(vars, this, data => {
          console.log(data,'dsssd')
          if (data.data && data.data.data) {
            this.otherActivty = data.data.data;
            this.otherActivty.map(item => {
              item.imgUrl = JSON.parse(item.banner)[0].$path
              item.publish_time = item.updatedate.substr(5, 5);
            })
          }
        });
      },
      goBack (e) {
        this.$router.push({
          name: 'back',
          query: {id: e.id}
        })
      }
    },
    created() {
    },
    mounted() {
      if (this.$route.query.id) {
        this.getActivtyData(this.$route.query.id);
      }
      this.getOtherActivtyData();
    }
  };
</script>

<style scoped>
  .activty-box {
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    border: solid 1px #eeeeee;
    margin-top: 30px;
    position: relative;
    padding: 30px;
  }

  .activty-img-box {
    width: 440px;
    height: 260px;
    position: absolute;
    left: -20px;
    top: -20px;
    background-color: rosybrown;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .activty-img-box img {
    width: 440px;
    height: 260px;
    border-radius: 8px;
  }

  .activty-list {
    display: flex;
    flex-direction: column;
  }

  .activty-top {
    width: 648px;
    height: 230px;
    margin-left: 450px;
    display: flex;
    flex-direction: column;
  }

  .activty-title {
    font-size: 24px;
    color: #000000;
  }

  .activty-top-time {
    margin-top: 15px;
  }

  .activty-top-address {
    margin-top: 15px;
    letter-spacing: 1px;
  }

  .activty-top-time-l {
    font-size: 14px;
  }

  .activty-top-time-r {
    color: #aaaaaa;
    font-size: 14px;
    margin-left: 30px;
  }

  .activty-top-auther {
    font-size: 14px;
    margin-top: 30px;
  }

  .activty-med {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  }

  .activty-med-l {
    font-size: 16px;
    color: #333333;
  }

  .price-list {
    display: flex;
    flex-direction: row;
  }

  .price-box {
    padding: 10px;
    border: 2px solid rgba(175, 9, 11, 1);
    background: #fff;
    color: rgba(175, 9, 11, 1);
    width: 250px;
    height: 60px;
    border-radius: 8px;
    margin-left: 40px;
    display: flex;
    flex-direction: column;
  }

  .introduce {
    color: #17a347;
    font-size: 12px;
    margin-left: 40px;
    margin-top: 15px;
  }

  .activty-bot {
    margin-left: 100px;
    margin-top: 15px;
  }

  .activty-bot-btn {
    font-size: 16px;
    width: 136px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    box-sizing: border-box;
    border-radius: 20px;
    color: white;
    background-color: rgba(175, 9, 11, 1);
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }

  .activty-bot-btn:hover {
    background-color: rgba(175, 9, 11, .6);
  }
  .activty-top-introduce{
    /*color: #2e2e2e;*/
    margin-top: 10px;
    font-size: 18px;
    line-height: 1.5;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .activty-rich-title{
    font-size: 20px;
    color: #333;
    border-bottom: none;
    margin-top: 24px;
  }
  .activty-rich{
    background-color: #ffffff;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    border: solid 1px #eeeeee;
    padding: 26px;
    margin-top: 24px;
    margin-bottom: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activty/activty-detail.vue